import React from 'react';
import { connect } from 'react-redux';
import { formValueSelector, getFormSyncErrors, getFormAsyncErrors } from 'redux-form';
import withStyles from '@material-ui/core/styles/withStyles';

import FirstPageHeader from './FirstPageHeader';
import ReduxSuperForm from './ReduxSuperForm';
import ReviewApplicationHeader from '../ReviewApplicationHeader';


import ReviewApplication from '@shorelight/super-form/components/ReviewApplication';

import {
  reviewApplicationPage,
  goToPageApplication,
  updatePageProgress,
  highlightMissingFields
} from '../../redux/application/application';
import { submitForm } from '../../redux/form/form';

import { canCreateLead } from '../componentsUtils';
import { FORM_NAME, FORM_PAGE_NAME, FORM_SUBMIT } from '../../constants';

const styles = (theme) => ({
  reviewApplicationContainer: {
    marginTop: theme.spacing(37)
  }
});

class SuperFormContainer extends React.Component {
  handlePageOnSubmit = (event) => {
    event.preventDefault();
    event.stopPropagation();

    return this.props.handlePageOnSubmit(this.props.formValues);
  };

  handleApplicationSubmit = (event) => {
    event.preventDefault();
    event.stopPropagation();

    return this.props.handleApplicationSubmit(this.props.applicationValues);
  };

  render() {
    if (this.props.reviewingApplication) {
      return (
        <div className={this.props.classes.reviewApplicationContainer}>
          <ReviewApplication
            customHeader={ReviewApplicationHeader}
            hasFooter={true}
            schema={this.props.schema}
            formValues={this.props.applicationValues}
            editPageApplication={this.props.handleEditPage}
            formSubmitName={FORM_SUBMIT}
            handleApplicationSubmit={this.handleApplicationSubmit}
            formSubmitting={this.props.formSubmitting}
            formSubmitError={this.props.formSubmitError && this.props.formSubmitError.content}
          />
        </div>
      );
    }

    return (
      <ReduxSuperForm
        dispatch={this.props.dispatch}
        currentPage={this.props.currentPage}
        formPageName={FORM_PAGE_NAME}
        schema={this.props.schema}
        initialValues={this.props.applicationValues}
        formValues={this.props.formValues}
        progressMap={this.props.progressMap}
        isNavigationDisabled={!canCreateLead(this.props.formValues, this.props.formSyncErrors)}
        hasFooter={true}
        isSaving={false}
        invalidEmail={false}
        lastSaveTime={null}
        submittingToReview={false}
        formSyncErrors={this.props.formSyncErrors}
        formAsyncErrors={this.props.formAsyncErrors}
        handleSelectPage={this.props.handleSelectPage}
        handleUpdatePageProgress={this.props.handleUpdatePageProgress}
        handleHighlightMissingFields={this.props.handleHighlightMissingFields}
        handlePageOnSubmit={this.handlePageOnSubmit}
      />
    );
  }
}

const selector = formValueSelector(FORM_NAME); // same as form name

const mapStateToProps = (state) => {
  const formIds = state.customForm.formIds;
  const schema = state.customForm.form;

  if (schema) {
    schema.pages[0] = {
      ...schema.pages[0],
      pageHeader: <FirstPageHeader />
    };
  }

  return {
    schema,
    formValues: formIds && schema ? selector(state, ...formIds) : {},
    formSyncErrors: getFormSyncErrors(FORM_NAME)(state),
    formAsyncErrors: getFormAsyncErrors(FORM_NAME)(state),
    currentPage: state.application.pageNumber,
    progressMap: state.application.progressMap,
    reviewingApplication: state.application.reviewingApplication,
    applicationValues: state.application.values,
    formSubmitting: state.customForm.formSubmitting,
    formSubmitError: state.customForm.formSubmitError
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    dispatch,
    handlePageOnSubmit: (values) => {
      dispatch(reviewApplicationPage(values));
    },
    handleUpdatePageProgress: (formSyncErrors, pageNumber) => {
      dispatch(updatePageProgress(formSyncErrors, pageNumber));
    },
    handleHighlightMissingFields: () => {
      dispatch(highlightMissingFields());
    },
    handleSelectPage: (pageNumber) => {
      dispatch(goToPageApplication(pageNumber));
    },
    handleEditPage: (pageNumber) => {
      dispatch(goToPageApplication(pageNumber));
    },
    handleApplicationSubmit: (values) => {
      dispatch(submitForm(values));
    }
  };
};

export default withStyles(styles)(connect(mapStateToProps, mapDispatchToProps)(SuperFormContainer));
